module.exports = __webpack_public_path__ + "static/media/google-play-badge.2b02e94d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Home/static/images/google-play-badge.svg
// module id = 87
// module chunks = 1